import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '../../store/feature/authSlice';
import {
  countriesSelector,
  getTenantCountriesList,
} from '../../store/feature/countrySlice';
import PhoneInput from 'react-phone-input-2';

const PhoneNumberInput = ({ number, setNumber, name }) => {
  const dispatch = useDispatch();
  const { tenant_countries_list } = useSelector(countriesSelector);

  console.log(number && number !== '' ? `+${number}` : '');

  useEffect(() => {
    dispatch(getTenantCountriesList());
  }, []);

  return (
    <div
      className="  mt-1
                    block
                    w-full
                    rounded-input
                    even:
                    border border-gray-300 shadow-sm transition  duration-700
                    focus:ring-0 focus:border-primary"
    >
      <PhoneInput
        onlyCountries={tenant_countries_list?.map((country) => {
          return country.code2.toLowerCase();
        })}
        country={
          tenant_countries_list?.filter((cn) => {
            if (number && number !== '') {
              return number?.startsWith(cn.dial_code);
            } else {
              return cn?.default == true;
            }
          }).length > 0
            ? tenant_countries_list
                ?.filter((cn) => {
                  if (number && number !== '') {
                    return (
                      number?.startsWith(cn.dial_code) ||
                      number?.startsWith(`+${cn.dial_code}`)
                    );
                  } else {
                    return cn?.default == true;
                  }
                })?.[0]
                ?.code2?.toLowerCase()
            : tenant_countries_list?.[0]?.code2?.toLowerCase()
        }
        value={number && number !== '' ? number : ''}
        onChange={(mobile, country, e) => {
          setNumber(`+${mobile}`);
        }}
        name={name}
      />
    </div>
  );
};

export default PhoneNumberInput;
